import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const AssetTypeAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    name: '',
    description: '',
    descriptionLang2: '',
    status: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });

  const [currentObjAttrs, setCurrentObjAttrs] = useState([]);

  const classList = [
    { key: "STANDARD", value: "STANDARD" },
    { key: "VIRTUAL",  value: "VIRTUAL" }
  ];

  // Initialize state
  useEffect(() => {

    if (props) {
      fetchObj(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("asset-types/" + id);

        resolve(res.data);

        if (res.status === 200) {
          setObjAttrs(res.data[0]);
          setCurrentObjAttrs(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onClassSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, class: key })
  };

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setObjAttrs(currentObjAttrs);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (objAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 50);
      return;

    } else if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
      return;

    } else if (objAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (objAttrs.class.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_class") + 20);
      return;
    } else if (objAttrs.status.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_status") + 50);
      return;
    }

    // Deep copy
    let tmpAttrs = JSON.parse(JSON.stringify(objAttrs));

    const reqBody = tmpAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.put("asset-types/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);

          fetchObj(objAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST');
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Asset_Type_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Asset_type_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Asset_type_code")}: *</Col>
                  <Col>{t("I18N_Name")}: *</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col>{t("I18N_Class")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={objAttrs.code}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                              name="description" value={objAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={ !objAttrs.class || (objAttrs.class === '') ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + objAttrs.class)}
                      onSelect={onClassSelect}>
                      {classList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("common:I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Asset_type_code")}:</Col>
                <Col>{t("I18N_Name")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_Class")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.code}</Col>
                <Col>{objAttrs.name}</Col>
                <Col style={{maxHeight:'120px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {objAttrs.description}
                </Col>
                <Col>{objAttrs.class ? t("I18N_" + objAttrs.class) : ''}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Updated_by")}:</Col>
                  <Col>{t("I18N_Time_updated")}:</Col>
                  <Col>{t("I18N_Created_by")}:</Col>
                  <Col>{t("I18N_Time_created")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.updaterUsername}</Col>
                <Col>{formatDate(objAttrs.timeUpdated)}</Col>
                <Col>{objAttrs.creatorUsername}</Col>
                <Col>{formatDate(objAttrs.timeCreated)}</Col>
              </Row>
            </Container>
          }
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {updateObjErrMsg}
            </span>
*/}
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default AssetTypeAdminDetailsView;
